import { Navigate, Outlet } from "react-router-dom";

import { useAppSelector } from "@/store";
import { routes } from "@/routes";

export const ProtectedRoute = () => {
    const token = useAppSelector((state) => state.auth.token);
    if (!token) return <Navigate to={routes.login.path} replace />;
    return <Outlet />;
};
